import httpClient from '../httpClient';

const createFillOutForm = async (data) => {
  return await httpClient.post(`fill_out_form/`, data);
};

const getFillOutForm = async (id) => {
  return await httpClient.get(`fill_out_form/${id}/`);
};

const updateFillOutForm = async (id, data) => {
  return await httpClient.patch(`fill_out_form/${id}/`, data);
};

const deleteFillOutForm = async (id) => {
  return await httpClient.delete(`fill_out_form/${id}/`);
};

const setFillOutFormCompleted = async (data) => {
  return await httpClient.post(`fill_out_form/set_completed/`, data);
};

const queryFillOutForm = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/fill_out_form/?page[number]=${page}&page[size]=${pageSize}${sortBy}${searchBy}`,
    { params: query },
  );
};

export {
  createFillOutForm,
  getFillOutForm,
  updateFillOutForm,
  deleteFillOutForm,
  queryFillOutForm,
  setFillOutFormCompleted,
}
